// extracted by mini-css-extract-plugin
module.exports = {"Row":"ClientInvoiceDetails_Row__e2n7q","Wrapper":"ClientInvoiceDetails_Wrapper__pBHdK","invoiceId":"ClientInvoiceDetails_invoiceId__OW3Sx"};